import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MediaTile from './MediaTile';
import { resolvePreviewUrl, makePendingPlaceholder, useObjectUrlGc } from './mediaLogic';
import './media.css';

// Контролируемый одиночный медиа-виджет (обложка, иконка санкции, аудио-слот).
// Не загружает сам — родитель шлёт multipart (value, pendingFile).
export default function AppMedia({ value, pendingFile, onChange, type, disabled }) {
    const items = useMemo(() => (value ? [value] : []), [value]);
    useObjectUrlGc(items);

    const previewUrl = resolvePreviewUrl(value || (pendingFile ? makePendingPlaceholder(pendingFile) : null));

    const handleSelect = (file) => { if (onChange) onChange(makePendingPlaceholder(file), file); };
    const handleRemove = () => { if (onChange) onChange(null, null); };

    return (
        <MediaTile
            type={type}
            url={previewUrl}
            onSelect={disabled ? null : handleSelect}
            onRemove={disabled ? null : handleRemove}
            disabled={disabled}
        />
    );
}

AppMedia.propTypes = {
    value: PropTypes.object,
    pendingFile: PropTypes.object,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['IMAGE', 'AUDIO', 'VIDEO']),
    disabled: PropTypes.bool
};

AppMedia.defaultProps = { value: null, pendingFile: null, onChange: null, type: 'IMAGE', disabled: false };
